import React from 'react';
import { Mutation, MutationComponentOptions } from '@apollo/client/react/components';

import subscribeMutation, {
    subscribePostMutation,
    subscribePostMutationVariables,
} from './mutations/subscribe.graphql';
import unsubscribeMutation, {
    unsubscribePostMutation,
    unsubscribePostMutationVariables,
} from './mutations/unsubscribe.graphql';

export interface Props {
    id: string;
    isSubscribed: boolean;
    children: (
        subscribePost: MutationComponentOptions<subscribePostMutation, subscribePostMutationVariables>,
        unsubscribePost: MutationComponentOptions<unsubscribePostMutation, unsubscribePostMutationVariables>
    ) => React.ReactNode;
}

class SubscribeUnsubscribePost extends React.PureComponent<Props> {
    render() {
        return (
            <Mutation<subscribePostMutation, subscribePostMutationVariables>
                mutation={subscribeMutation}
                optimisticResponse={{
                    subscribePost: {
                        __typename: 'SubscribePostPayload',
                        post: {
                            __typename: 'PostNode',
                            id: this.props.id,
                            isSubscribedByViewer: true,
                        },
                    },
                }}
            >
                {subscribePost => (
                    <Mutation<unsubscribePostMutation, unsubscribePostMutationVariables>
                        mutation={unsubscribeMutation}
                        optimisticResponse={{
                            unsubscribePost: {
                                __typename: 'UnsubscribePostPayload',
                                post: {
                                    __typename: 'PostNode',
                                    id: this.props.id,
                                    isSubscribedByViewer: false,
                                },
                            },
                        }}
                    >
                        {unsubscribePost => this.props.children(subscribePost, unsubscribePost)}
                    </Mutation>
                )}
            </Mutation>
        );
    }
}

export default SubscribeUnsubscribePost;
